import React from 'react'
import { Row, Col, Card, Table, Statistic, Badge, Space, Typography } from 'antd'
import { formatOccupancyRate } from '../utils/formatters'

const { Text } = Typography

const WardSummary = ({ wardSummaryData }) => {
  const summaryColumns = [
    {
      title: 'Ward',
      dataIndex: 'ward',
      key: 'ward'
    },
    {
      title: 'Total Beds',
      dataIndex: 'totalBeds',
      key: 'totalBeds'
    },
    {
      title: 'Occupied',
      dataIndex: 'occupiedBeds',
      key: 'occupiedBeds'
    },
    {
      title: 'Available',
      dataIndex: 'availableBeds',
      key: 'availableBeds'
    },
    {
      title: 'Cleaning',
      dataIndex: 'cleaningBeds',
      key: 'cleaningBeds'
    },
    {
      title: 'Occupancy Rate',
      dataIndex: 'occupancyRate',
      key: 'occupancyRate',
      render: (rate) => formatOccupancyRate(rate)
    }
  ]

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        {wardSummaryData.map((wardSummary) => (
          <Col xs={24} sm={12} md={8} lg={6} key={wardSummary.ward}>
            <Card title={wardSummary.ward} size='small'>
              <Statistic
                title='Occupancy Rate'
                value={wardSummary.occupancyRate}
                suffix='%'
                valueStyle={{
                  color:
                    wardSummary.occupancyRate > 90 ? '#cf1322' : wardSummary.occupancyRate > 75 ? '#faad14' : '#3f8600'
                }}
              />
              <div style={{ marginTop: '8px' }}>
                <Text>Total: {wardSummary.totalBeds}</Text>
                <br />
                <Space>
                  <Badge status='error' text={`Occupied: ${wardSummary.occupiedBeds}`} />
                  <Badge status='success' text={`Available: ${wardSummary.availableBeds}`} />
                </Space>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Table columns={summaryColumns} dataSource={wardSummaryData} rowKey='ward' pagination={false} />
    </>
  )
}

export default WardSummary
